import { useQuery } from '@tanstack/react-query';
import { getPhoneStats } from '../lib/api';

/**
 * A MAI nap, magyar ido szerint (YYYY-MM-DD).
 *
 * Nem a gep sajat idozonajat hasznaljuk: a statisztika napjai budapestiek, es
 * egy kulfoldon ulo kolléga "ma"-ja ne csusszon el tole.
 */
export function budapestToday(offsetDays = 0): string {
  const at = new Date(Date.now() + offsetDays * 86_400_000);
  return new Intl.DateTimeFormat('sv-SE', { timeZone: 'Europe/Budapest' }).format(at);
}

export interface PhoneStatsFilter {
  from: string;
  to: string;
  users: string[];
  direction: 'all' | 'inbound' | 'outbound';
}

export const phoneStatsKey = (channelId: string, filter: PhoneStatsFilter) =>
  ['phone-stats', channelId, filter] as const;

export function usePhoneStats(
  channelId: string,
  filter: PhoneStatsFilter,
  options: { enabled?: boolean; live?: boolean } = {},
) {
  return useQuery({
    queryKey: phoneStatsKey(channelId, filter),
    queryFn: () => getPhoneStats(channelId, filter),
    enabled: options.enabled ?? true,
    // A mai szamok hivas kozben is frissuljenek; a regi idoszak nem valtozik.
    refetchInterval: options.live ? 30_000 : false,
    staleTime: options.live ? 15_000 : 5 * 60_000,
  });
}
